import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/next-casino/next-casino/app/src/server/components/PagesRouterAdapter/ClientPagesRouterAdapter/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/next-casino/next-casino/app/src/server/components/TournamentsComponent/index.tsx");
